import join from "lodash/join";
import map from "lodash/map";
import round from "lodash/round";

const INTERPOLATION_COUNT = 50;

export function buildTableValues(polynom1Coefs: number[], polynom2Coefs?: number[]): string {
  let table = interpolateLinear(INTERPOLATION_COUNT);

  table = interpolatePolynom(table, polynom1Coefs);

  if (polynom2Coefs) {
    table = interpolatePolynom(table, polynom2Coefs);
  }

  return tableToTableValues(table);
}

export function interpolateLinear(count: number): number[] {
  const table: number[] = [];

  for (let value = 0; value <= count; value += 1) {
    table.push(value / count);
  }

  return table;
}

export function interpolatePolynom(table: number[], coefs: number[]): number[] {
  return map(table, (value) => {
    let result = 0;

    for (let i = coefs.length - 1; i >= 0; i--) {
      const coef = coefs[i];
      const power = coefs.length - i - 1;

      result += coef * value ** power;
    }

    return result;
  });
}

export function tableToTableValues(table: number[]): string {
  return join(
    map(table, (value) => round(value, 3)),
    " "
  );
}
